import React, { PureComponent } from 'react';
import { Button, PopOver, Portal } from '@tencent/spaui';
import './guide-manager.scoped.less';

class GuideManager extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      index: 0,
      displayGuideList: [],
      positionTop: null,
      positionLeft: null,
    };
  }

  componentDidMount() {
    const { flag, guidList = [] } = this.props;
    const displayGuideList = guidList
      .map((item) => {
        const el = document.querySelector(`#${item.key}[data-mark='guide']`);
        return {
          ...item,
          el,
        };
      })
      .filter((item) => item.el);

    setTimeout(() => {
      const hasGuide = localStorage.getItem(flag);
      if (displayGuideList.length && !hasGuide) {
        const position = this.calculatePosition(0, displayGuideList);
        this.setState({ show: true, displayGuideList, ...position });
      }
    });
  }

  handlePre = () => {
    const { displayGuideList, index } = this.state;
    if (index > 0) {
      this.setState({ index: index - 1 });
    }
  }

  handleNext = () => {
    const { displayGuideList, index } = this.state;
    if (index < displayGuideList.length - 1) {
      this.setState({ index: index + 1 });
    } else {
      this.handleClose();
    }
  }

  handleClose = () => {
    const { flag } = this.props;
    localStorage.setItem(flag, 1);
    this.setState({ show: false });
  }

  render() {
    const { show, displayGuideList, index, positionTop, positionLeft } = this.state;
    const currentItem = displayGuideList[index] || {};

    return (
      <Portal>
        <PopOver {...this.props} show={show} placement="bottom" positionTop={positionTop} positionLeft={positionLeft} className="dark single-guide-popover">
          <h4 className="spaui-popover-title">{currentItem.label}</h4>
          <div className="spaui-popover-body">{currentItem.desc}</div>

          <div className="spaui-popover-footer">
            {index > 0 ? (
              <Button bsSize="small" bsStyle="primary" onClick={this.handlePre}>
                上一步
              </Button>
            ) : null}
            <Button bsSize="small" bsStyle="primary" onClick={this.handleNext}>
              {index === displayGuideList.length - 1 ? '完成' : '下一步'}
            </Button>
          </div>

          <a className="spaui-popover-close" href="#" onClick={this.handleClose}>
            <i className="spaui-icon icon-plus icon-close"></i>
          </a>
        </PopOver>
      </Portal>
    );
  }

  calculatePosition(index, displayGuideList) {
    const currentItem = displayGuideList[index] || {};
    const el = document.querySelector(`#${currentItem.key}[data-mark='guide']`);
    if (el) {
      const { left, right, bottom } = el.getBoundingClientRect();
      return {
        positionTop: bottom,
        positionLeft: (left + right) / 2,
      };
    }
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevState.index !== this.state.index) {
      return this.calculatePosition(this.state.index, this.state.displayGuideList);
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      this.setState(snapshot);
    }
  }
}

export default GuideManager;
